import { getCategoryChildrenType } from './chunk-F6KAEMDT.mjs';
import isEmpty from 'lodash/isEmpty';

var menuItemCardFactoryCore = (items, categories, subcategories, menuTypes) => {
  return Object.values(items).map((item) => {
    const categoryIdSet = /* @__PURE__ */ new Set();
    const subcategoryIdSet = /* @__PURE__ */ new Set();
    Object.values(item.menuTypeVersions).forEach((menuTypeVersion) => {
      var _a;
      Object.values((_a = menuTypeVersion.categoriesSubcategories) != null ? _a : {}).forEach(
        ({ categoryId, subcategoryId }) => {
          if (categoryId)
            categoryIdSet.add(categoryId);
          if (subcategoryId)
            subcategoryIdSet.add(subcategoryId);
        }
      );
    });
    const statuses = {};
    Object.values(item.menuTypeVersions).map((menuTypeVersion) => {
      statuses[menuTypeVersion.id] = menuTypeVersion.active;
    });
    return {
      id: item.itemId,
      title: item.name,
      upc: Array.from(
        new Set(
          Object.values(item.menuTypeVersions).filter(
            (menuTypeVersion) => Boolean(menuTypeVersion.universalProductCode)
          ).map((menuTypeVersion) => menuTypeVersion.universalProductCode)
        )
      ),
      categoryId: Array.from(categoryIdSet),
      subcategoryId: Array.from(subcategoryIdSet),
      menuTypeId: Object.values(item.menuTypeVersions).map(
        (menuTypeVersion) => menuTypeVersion.menuTypeId
      ),
      statuses,
      reportingGroupIds: item.reportingGroupIds,
      isHidden: getIsItemHiddenCore(
        item.menuTypeVersions,
        categories,
        subcategories,
        "items",
        item.itemId,
        menuTypes
      ),
      isActive: Object.values(item.menuTypeVersions).some(
        (menuType) => menuType.active === true
      )
    };
  });
};
var HiddenBucket = /* @__PURE__ */ ((HiddenBucket2) => {
  HiddenBucket2["category"] = "category";
  HiddenBucket2["subcategory"] = "subcategory";
  return HiddenBucket2;
})(HiddenBucket || {});
var HiddenReason = /* @__PURE__ */ ((HiddenReason2) => {
  HiddenReason2["empty"] = "empty";
  HiddenReason2["inactive"] = "inactive";
  HiddenReason2["simpleMode"] = "simpleMode";
  return HiddenReason2;
})(HiddenReason || {});
var getIsItemHiddenCore = (menuTypeVersions, categories, subcategories, bucket, itemId, menuTypes) => {
  const isHidden = Object.values(menuTypeVersions).every(
    (menuTypeVersion) => getIsMenuTypeItemHiddenCore(
      menuTypeVersion.categoriesSubcategories,
      categories,
      subcategories,
      bucket,
      itemId,
      menuTypeVersion.menuTypeId,
      menuTypes
    ).isHidden
  );
  return isHidden;
};
var getIsMenuTypeItemHiddenCore = (categoriesSubcategories, categories, subcategories, bucket, itemId, menuTypeVersionId, menuTypes, enableSimpleMode) => {
  var _a, _b, _c;
  const categoriesSubcategoriesArray = Object.values(
    categoriesSubcategories != null ? categoriesSubcategories : {}
  );
  const singleEntry = categoriesSubcategoriesArray.length === 1;
  const singleCategoryId = singleEntry ? categoriesSubcategoriesArray[0].categoryId : 0;
  const singleSubcategoryId = singleEntry ? categoriesSubcategoriesArray[0].subcategoryId : 0;
  const singleCategory = categories[singleCategoryId || 0];
  const singleSubcategory = subcategories[Number(singleSubcategoryId || 0)];
  const isAtLeastOneCategoryActive = categoriesSubcategoriesArray.some(
    ({ categoryId }) => {
      const category = categories[categoryId || 0];
      return category == null ? void 0 : category.active;
    }
  );
  let isHiddenDueSimpleMode = false;
  let isNotHiddenDueHomeScreen = false;
  let isHidden = categoriesSubcategoriesArray.every(
    ({ categoryId, subcategoryId }) => {
      const category = categories[categoryId || 0];
      const isCategoryActive = category == null ? void 0 : category.active;
      const childrenType = getCategoryChildrenType(
        (category == null ? void 0 : category.subcategoryMenuTypeItemsIds) || {},
        (category == null ? void 0 : category.subcategoryMenuTypeCombosIds) || {}
      );
      const subcategory = subcategories[Number(subcategoryId || 0)];
      const isSubcategoryHidden = Boolean(subcategoryId) && !(subcategory == null ? void 0 : subcategory.active) && childrenType === "subcategory" /* SUBCATEGORY */;
      return !isCategoryActive || isSubcategoryHidden;
    }
  );
  if (menuTypeVersionId && menuTypes) {
    const menuType = menuTypes[menuTypeVersionId];
    const mapFn = (homeScreenElement) => homeScreenElement.bucketId;
    const homeScreenCategories = ((_a = menuType == null ? void 0 : menuType.homeScreenElements) != null ? _a : []).filter(
      (homeScreenElement) => homeScreenElement.type === "category" /* CATEGORY */
    ).map(mapFn);
    const homeScreenSubcategories = ((_b = menuType == null ? void 0 : menuType.homeScreenElements) != null ? _b : []).filter(
      (homeScreenElement) => homeScreenElement.type === "subcategory" /* SUBCATEGORY */
    ).map(mapFn);
    const homeScreenItems = ((_c = menuType == null ? void 0 : menuType.homeScreenElements) != null ? _c : []).filter(
      (homeScreenElement) => homeScreenElement.type === (bucket === "items" ? "item" /* ITEM */ : "combo" /* COMBO */)
    ).map(mapFn);
    if (menuType == null ? void 0 : menuType.enableSimpleMode) {
      isHiddenDueSimpleMode = categoriesSubcategoriesArray.every(
        ({ categoryId, subcategoryId }) => {
          if (homeScreenCategories.includes(categoryId || 0) || homeScreenSubcategories.includes(subcategoryId || 0) || homeScreenItems.includes(itemId || 0)) {
            return false;
          }
          return true;
        }
      );
    } else if (homeScreenItems.includes(itemId || 0)) {
      isNotHiddenDueHomeScreen = true;
    }
  }
  if (isHiddenDueSimpleMode && enableSimpleMode !== false) {
    isHidden = true;
  }
  if (isNotHiddenDueHomeScreen) {
    isHidden = false;
  }
  return {
    isHidden,
    bucket: isHidden ? !isAtLeastOneCategoryActive ? "category" /* category */ : "subcategory" /* subcategory */ : "",
    id: isHidden ? !isAtLeastOneCategoryActive ? singleCategoryId : singleSubcategoryId : 0,
    name: isHidden ? !isAtLeastOneCategoryActive ? singleCategory == null ? void 0 : singleCategory.name : singleSubcategory == null ? void 0 : singleSubcategory.name : "",
    reason: isHiddenDueSimpleMode ? "simpleMode" /* simpleMode */ : isEmpty(categoriesSubcategories != null ? categoriesSubcategories : {}) ? "empty" /* empty */ : "inactive" /* inactive */
  };
};

export { HiddenBucket, HiddenReason, getIsItemHiddenCore, getIsMenuTypeItemHiddenCore, menuItemCardFactoryCore };
